import { render, staticRenderFns } from "./PsychologistPage.vue?vue&type=template&id=afa73dac&"
import script from "./PsychologistPage.vue?vue&type=script&lang=ts&"
export * from "./PsychologistPage.vue?vue&type=script&lang=ts&"
import style0 from "./PsychologistPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports